
<template>
    <div class="MarketSentimentCard">
        <div v-if="accessDenied">
            <div class="NoDataFound">
                <div class="text-center no-data-container">
                    Access Denied
                </div>
            </div>
        </div>
        <div class="innerSentimentCard" v-else>
            <el-card class="box-card" v-loading="isStockDetailsLoading">
                <div style="position: relative; min-height: 645px;">
                    <div>
                        <div class="sentiment-options">
                            <div class="font-09rem font-weight-600 bottom-margin-10">Market Sentiment <img class="info-Logo"
                                    src="../../assets/images/Market sentiment logo 1.svg" width="15px"
                                    style=" height: 12px !important;" alt />
                            </div>
                        </div>
                        <div v-if="selectedSegment == 'Equity'">
                            <div class="stock-details" v-if="stockDetails">
                                <div class="stock-name">
                                    {{ stockDetails.name }} <span class="more-btn">more</span>
                                </div>
                                <div class="stock-price">
                                    &#8377;{{ stockDetails.current_price }}
                                    <span class="cursor-pointer" :style="[
                                        stockDetails.price_difference < 0
                                            ? { color: '#e72726' }
                                            : { color: '#16db16' },
                                    ]">
                                        <i v-if="stockDetails.price_difference < 0" class="el-icon-caret-bottom"></i>
                                        <i v-else class="el-icon-caret-top"></i>
                                        {{ stockDetails.price_difference }}({{
                                            stockDetails.potential_difference
                                        }}%)
                                    </span>
                                </div>
                                <div class="stock-date">
                                    {{
                                        moment(stockDetails.current_datetime).format(
                                            "DD MMMM YYYY, hh:mm A"
                                        )
                                    }}
                                </div>

                                <div class="btn-blocks">
                                    <div class="plane-btn">{{ stockDetails.market_cap }}</div>
                                    <div class="plane-btn">{{ stockDetails.sector }}</div>
                                </div>
                            </div>

                            <div class="main-tabs">
                                <el-tabs type="border-card" v-model="activeTab" @tab-click="handleTabClick">
                                    <el-tab-pane name="Price Sentiment" v-if="sentimentData">
                                        <span slot="label">Price Sentiment</span>
                                        <div class="price-sentiment-inner-card">
                                            <el-tabs tab-position="top" style="">
                                                <el-tab-pane label="Expert View">
                                                    <div class="expert-view">
                                                        <div class="market-type-dropdown ">
                                                            <div class="target-period">
                                                                Target Period
                                                            </div>
                                                            <el-select style="width:100%" v-model="selectedTargetPeriod"
                                                                placeholder="Select" @change="
                                                                    filterDataForSentimentCard(
                                                                        selectedTargetPeriod
                                                                    )
                                                                    ">
                                                                <el-option v-for="item in targetPeriod" :key="item.value"
                                                                    :label="item.label" :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                    <div class="expert-view" id="expertView" v-if="sentimentData">
                                                        <div class="graph-section">
                                                            <el-row>
                                                                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                                                    <div style="height: 155px!important;">
                                                                        <div ref="reco_graph" style="width: 100%; min-height: 350px; position: relative; top: 0px;  margin: 0 auto; display: flex;
        justify-content: center;"></div>
                                                                    </div>
                                                                    <div>
                                                                        <div class="text-center percentage-txt">
                                                                            Percentage of <br />
                                                                            Recommendation
                                                                        </div>
                                                                    </div>
                                                                </el-col>

                                                                <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                                                                    <div class="antestimate">
                                                                        <div class="antestimate-card">
                                                                            <div>
                                                                                <div class="small-head">
                                                                                    Antestimate
                                                                                </div>
                                                                                <div class="mid-head">
                                                                                    &#8377 {{ sentimentData.ants_number
                                                                                    }}
                                                                                </div>
                                                                                <div class="small-head bottom-margin-15">
                                                                                    {{
                                                                                        sentimentData.ants_number_in_percent
                                                                                        ? "(" +
                                                                                        sentimentData.ants_number_in_percent
                                                                                        +
                                                                                        "%)"
                                                                                        : ""
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                            <!-- <div>Q2 2022</div> -->
                                                                        </div>
                                                                    </div>
                                                                </el-col>
                                                            </el-row>
                                                        </div>
                                                        <br />
                                                        <!-- style="position: relative; bottom: 90px;" -->
                                                        <div>
                                                            <br />
                                                            <div v-if="isProfessionsWiseExpertSectionOpen">
                                                                <div class="forecasted-user-table-outer">
                                                                    <table
                                                                        class="forecasted-user-table forecasted-user-table-one">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="text-align: left;">
                                                                                    Profession
                                                                                </th>
                                                                                <th>Number of Experts</th>
                                                                                <th>Antestimate</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr v-for="(item,
                                                                                index) in sentimentData.profession_wise_data"
                                                                                :key="index">
                                                                                <td style="text-align: left;">
                                                                                    <el-checkbox v-model="item.isChecked"
                                                                                        @change="
                                                                                            compareExpertFilterData(
                                                                                                item.title,
                                                                                                item.isChecked
                                                                                            )
                                                                                            ">
                                                                                        {{ item.title }}</el-checkbox>
                                                                                </td>
                                                                                <td>{{ item.count }}</td>
                                                                                <td>
                                                                                    &#8377 {{ item.ants_number }}
                                                                                    {{
                                                                                        item.ants_number_in_percent
                                                                                        ? " (" +
                                                                                        item.ants_number_in_percent +
                                                                                        ")"
                                                                                        : ""
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <NoDataFound v-if="!sentimentData.profession_wise_data"
                                                                    style="padding: 0;">
                                                                </NoDataFound>
                                                            </div>
                                                            <br />
                                                            <div class="text-center font-08rem see-more-tabs" @click="
                                                                isCompareSectionOpen = !isCompareSectionOpen
                                                                ">
                                                                Compare Expert
                                                                <i class="el-icon-arrow-down"
                                                                    v-if="isCompareSectionOpen"></i>
                                                                <i class="el-icon-arrow-up"
                                                                    v-if="!isCompareSectionOpen"></i>
                                                            </div>
                                                            <br />
                                                            <div v-if="isCompareSectionOpen">
                                                                <div class="forecasted-user-table-outer">
                                                                    <table
                                                                        class="forecasted-user-table forecasted-user-table-two">
                                                                        <thead>
                                                                            <tr>
                                                                                <th style="text-align: left;">
                                                                                    Experts
                                                                                </th>
                                                                                <th>Category</th>
                                                                                <th>Reco</th>
                                                                                <th>Target Price</th>
                                                                                <th>Status</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr v-for="expert in filteredExpertList">
                                                                                <td style="text-align:left">
                                                                                    <!-- <i
                                                class="el-icon-info font-08rem"
                                              ></i> -->
                                                                                    {{ expert.expert }}
                                                                                </td>
                                                                                <td>{{ expert.profession }}</td>
                                                                                <td :style="[
                                                                                    expert.reco == 'Buy'
                                                                                        ? { color: '#16db16' }
                                                                                        : { color: '#e72726' },
                                                                                ]">
                                                                                    {{ expert.reco }}
                                                                                </td>
                                                                                <td style="font-weight: 600;">
                                                                                    ₹ {{ expert.target_price }}
                                                                                </td>
                                                                                <td>{{ expert.reco_status_str }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <NoDataFound v-if="!filteredExpertList" style="padding: 0;">
                                                                </NoDataFound>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <NoDataFound v-if="!sentimentData" style="padding: 0;">
                                                    </NoDataFound>
                                                </el-tab-pane>
                                                <!-- <el-tab-pane label="Forecast">Forecast</el-tab-pane>
                                  <el-tab-pane label="Logic">Logic</el-tab-pane> -->
                                            </el-tabs>
                                        </div>
                                    </el-tab-pane>

                                    <!-- <el-tab-pane label="Real Trade">Real Trade</el-tab-pane> -->
                                    <el-tab-pane name="Technical Analysis">
                                        <span slot="label">Technical Analysis</span>
                                        <div class="tradingview-widget-container" style="margin-top: 20px;">
                                            <div class="tradingview-widget-container__widget"></div>
                                            <div class="tradingview-widget-copyright">
                                                <a href="https://in.tradingview.com/" rel="noopener nofollow"
                                                    target="_blank">
                                                    <span class="blue-text">Track all markets on TradingView</span>
                                                </a>
                                            </div>
                                        </div>

                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <!-- <NoDataFound v-if="!stockDetails.name" style="padding: 0;"></NoDataFound> -->
                        </div>

                        <div v-if="selectedSegment == 'Options'">
                            <div>
                                <div class="stock-details">
                                    <div class="stock-name">
                                        BANKNIFTY <span class="more-btn">more</span>
                                    </div>
                                    <div class="stock-price">
                                        &#8377;42988
                                        <span class="cursor-pointer" style="color:red">
                                            <!-- :style="[
                            stockDetails.price_difference < 0
                              ? { color: '#e72726' }
                              : { color: '#16db16' },
                          ]" -->
                                            <!-- <i
                            v-if="stockDetails.price_difference < 0"
                            class="el-icon-caret-bottom"
                          ></i>
                          <i v-else class="el-icon-caret-top"></i> -->
                                            <i class="el-icon-caret-bottom"></i>
                                            -130
                                        </span>
                                    </div>
                                    <div class="stock-date bottom-margin-20">
                                        {{
                                            moment(stockDetails.current_datetime).format(
                                                "DD MMMM YYYY, hh:mm A"
                                            )
                                        }}
                                    </div>

                                    <!-- <div class="btn-blocks">
                        <div class="plane-btn">{{ stockDetails.market_cap }}</div>
                        <div class="plane-btn">{{ stockDetails.sector }}</div>
                      </div> -->
                                </div>

                                <div class="main-tabs">
                                    <el-tabs type="border-card">
                                        <el-tab-pane>
                                            <span slot="label">Price Sentiment</span>

                                            <div class="price-sentiment-inner-card">
                                                <el-tabs tab-position="top" style="">
                                                    <el-tab-pane label="Expert View">
                                                        <div class="expert-view">
                                                            <div class="market-type-dropdown ">
                                                                <div class="target-period">
                                                                    Expiry
                                                                </div>
                                                                <el-select style="width:100%" v-model="selectedExpiry"
                                                                    placeholder="Select">
                                                                    <!-- @change="
                                        filterDataForSentimentCard(
                                          selectedTargetPeriod
                                        )
                                      " -->
                                                                    <el-option v-for="item in targetPeriod"
                                                                        :key="item.value" :label="item.label"
                                                                        :value="item.value">
                                                                    </el-option>
                                                                </el-select>
                                                            </div>
                                                        </div>
                                                        <div class="expert-view" id="expertView" v-if="sentimentData">
                                                            <div class="graph-section">
                                                                <el-row>
                                                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                                                        <div style="height: 155px!important;">
                                                                            <div ref="reco_graph"
                                                                                style="width: 100%; min-height: 350px; position: relative; top: -30px;  margin: 0 auto;">
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div class="text-center percentage-txt">
                                                                                Percentage of <br />
                                                                                Recommendation
                                                                            </div>
                                                                        </div>
                                                                    </el-col>

                                                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                                                        <div style="height: 155px!important;">
                                                                            <div ref="reco_graph"
                                                                                style="width: 100%; min-height: 350px; position: relative; top: -30px;  margin: 0 auto;">
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div class="text-center percentage-txt">
                                                                                Percentage of <br />
                                                                                Recommendation
                                                                            </div>
                                                                        </div>
                                                                    </el-col>
                                                                </el-row>
                                                            </div>
                                                            <br />
                                                            <!-- style="position: relative; bottom: 90px;" -->
                                                            <div>
                                                                <br />
                                                                <div class="text-center font-08rem see-more-tabs" @click="
                                                                    isCompareSectionOpen = !isCompareSectionOpen
                                                                    ">
                                                                    Compare Expert
                                                                    <i class="el-icon-arrow-down"
                                                                        v-if="isCompareSectionOpen"></i>
                                                                    <i class="el-icon-arrow-up"
                                                                        v-if="!isCompareSectionOpen"></i>
                                                                </div>
                                                                <br />
                                                                <div v-if="isCompareSectionOpen">
                                                                    <div class="forecasted-user-table-outer">
                                                                        <table
                                                                            class="forecasted-user-table forecasted-user-table-three">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style="text-align: left;">
                                                                                        Experts
                                                                                    </th>
                                                                                    <th>Category</th>
                                                                                    <th>Strategy</th>
                                                                                    <th>Capital Required</th>
                                                                                    <th>Potential</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr v-for="expert in filteredExpertList">
                                                                                    <td style="text-align:left">
                                                                                        <i
                                                                                            class="el-icon-info font-08rem"></i>
                                                                                        {{ expert.expert }}
                                                                                    </td>
                                                                                    <td>{{ expert.profession }}</td>
                                                                                    <td :style="[
                                                                                        expert.reco == 'Buy'
                                                                                            ? { color: '#16db16' }
                                                                                            : { color: '#e72726' },
                                                                                    ]">
                                                                                        {{ expert.reco }}
                                                                                    </td>
                                                                                    <td style="font-weight: 600;">
                                                                                        ₹ {{ expert.target_price }}
                                                                                    </td>
                                                                                    <td>0.5%</td>
                                                                                    <td>{{ expert.reco_status_str }}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    <NoDataFound v-if="!filteredExpertList"
                                                                        style="padding: 0;"></NoDataFound>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <NoDataFound v-if="!sentimentData" style="padding: 0;">
                                                        </NoDataFound>
                                                    </el-tab-pane>
                                                    <!-- <el-tab-pane label="Forecast">Forecast</el-tab-pane>
                                  <el-tab-pane label="Logic">Logic</el-tab-pane> -->
                                                </el-tabs>
                                            </div>
                                        </el-tab-pane>

                                        <!-- <el-tab-pane label="Real Trade">Real Trade</el-tab-pane>
                        <el-tab-pane label="Technical Analysis"
                          >Technical Analysis</el-tab-pane
                        > -->
                                    </el-tabs>
                                </div>
                            </div>
                            <NoDataFound v-if="!stockDetails.name" style="padding: 0;"></NoDataFound>
                        </div>
                    </div>
                    <!-- <PremiumLock></PremiumLock> -->
                </div>
            </el-card>
        </div>
    </div>
</template>
    
<script>
var echarts = require("echarts");
import { graphData } from "../../mixins/HalfDonutGraphData";
import { serverAddr } from "../../networkConfig";
import { filterCallBack } from "../../mixins/filter";
import NoDataFound from "./../NoDataFound.vue";
import PremiumLock from "./../StockAntsLiteWidgets/WidgetLock.vue";
import moment from "moment";

export default {
    name: "MarketSentimentCard",

    components: {
        NoDataFound,
        PremiumLock,
    },

    props: ["stock_code", "broker_access_key"],

    mixins: [graphData, filterCallBack],

    data() {
        return {
            moment: moment,
            is_loading: false,
            selectedTargetPeriod: "",
            selectedSegment: "Equity",
            selectedExpiry: "30 Sept 2023",
            targetPeriod: [
                // {
                //   value: "intra",
                //   label: "Intra",
                // },
                // {
                //   value: "short_term",
                //   label: "Short Term",
                // },
                // {
                //   value: "mid_term",
                //   label: "Mid Term",
                // },
                // {
                //   value: "long_term",
                //   label: "Long Term",
                // },
            ],
            donutGraphInstance: "",
            donutGraphDetails: [
                // { value: 50, name: "data-a" },
                // { value: 20, name: "data-b" },
                // { value: 20, name: "data-c" },
                // { value: 10, name: "data-d" },
                // {
                //   value: 100,
                //   name: null,
                //   itemStyle: { opacity: 0 },
                //   tooltip: { show: false },
                // },
            ],
            professionWiseData: [],
            expertsData: [],
            isCompareSectionOpen: false,
            isProfessionsWiseExpertSectionOpen: true,
            stockDetails: {},
            isStockDetailsLoading: false,
            sentimentData: null,
            selectedExpertType: [],
            filteredExpertList: [],
            userProfile: null,
            sentimentResponseData: null,
            currentEnvironment: {},
            accessDenied: false,
            isWidgetAdded: false,
            activeTab: ''
        };
    },
    mounted() {
        this.getStockData();
        if (localStorage.getItem("currentEnvironment")) {
            this.currentEnvironment = JSON.parse(
                localStorage.getItem("currentEnvironment")
            );
        }
    },

    methods: {
        handleTabClick(tab) {
            if (tab.name == 'Technical Analysis' && !this.isWidgetAdded) {
                this.showTechnicalAnalysisWidget();
            }
        },
        showTechnicalAnalysisWidget() {
            this.activeTab = 'Technical Analysis'
            this.isWidgetAdded = true;

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                interval: '1m',
                width: '100%',
                isTransparent: true,
                height: '450',
                symbol: `NSE:${this.stock_code}`,
                showIntervalTabs: true,
                locale: 'in',
                colorTheme: 'light',
                border: 'none'
            });
            this.$el.querySelector('.tradingview-widget-container__widget').appendChild(script);
        },
        goToLogin(tag) {
            if (tag == "signIn") {
                this.$router.push({ name: "login" });
            } else {
                this.$router.push({ name: "login", params: { plan: "register" } });
            }
        },
        getStockData() {
            var stock_symbol = this.stock_code;
            // if (this.stock_code == undefined) {
            //   stock_symbol = "AARTIIND";
            // }

            this.isStockDetailsLoading = true;


            var url = this.broker_access_key
                ? `/market_dashboard/open_api/overview/stock/v1/sentiment_card/${this.broker_access_key}?scrip_id=${stock_symbol}`
                : `/market_dashboard/open_api/overview/stock/v1/sentiment_card?scrip_id=${stock_symbol}`;

            serverAddr
                .get(url)
                .then((response) => {
                    if (response.data.status) {
                        // let data = response.data.data;
                        this.sentimentResponseData = response.data.data;
                        this.stockDetails = this.sentimentResponseData.stock;
                        // this.sentimentData = data.sentiment_data;
                        this.isStockDetailsLoading = false;

                        if ( this.sentimentResponseData.length) {
                            this.sentimentResponseData.sentiment_data.forEach(element => {
                                this.targetPeriod.push({
                                    value: element.period,
                                    label: element.period == 'long_term' ? 'Long Term' : element.period == 'short_term' ? 'Short Term' : element.period == 'medium_term' ? 'Mid Term' : element.period == 'intra' ? 'Intra' : '',
                                })
                            });
                        }
                        this.filterDataForSentimentCard();
                    } else {
                        this.isStockDetailsLoading = false;
                        
                        if (this.broker_access_key) {
                            this.accessDenied = true
                        }

                        this.showTechnicalAnalysisWidget()
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        compareExpertFilterData(title, status) {
            if (status && !this.selectedExpertType.includes(title)) {
                this.selectedExpertType.push(title);

                if (!this.isCompareSectionOpen) {
                    this.isCompareSectionOpen = true;
                }
            } else {
                const index = this.selectedExpertType.indexOf(title);
                if (index > -1) {
                    // only splice this.selectedExpertType when item is found
                    this.selectedExpertType.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
            //  var experts_list = this.sentimentData.experts_data.filter(o => {return (o.address == 'England' || o.name == 'Mark')})

            this.filteredExpertList = this.sentimentData.experts_data.filter((item) =>
                this.selectedExpertType.includes(item.profession)
            );

            // scroll to top
            var objDiv = document.getElementById("expertView");
            objDiv.scrollTop = objDiv.scrollHeight;
        },

        filterDataForSentimentCard(target_period) {
            if (
                this.sentimentResponseData.sentiment_data != undefined &&
                this.sentimentResponseData.sentiment_data.length
            ) {

                this.donutGraphDetails = []

                //  select first value of available target period
                if (!target_period) {
                    var selectedTargetPeriod = this.targetPeriod.filter((e) => {
                        if (
                            e.value == this.sentimentResponseData.sentiment_data[0].period
                        ) {
                            return e.value;
                        }
                    });
                    this.selectedTargetPeriod = selectedTargetPeriod[0] ? selectedTargetPeriod[0].value : '';
                    this.sentimentData = this.sentimentResponseData.sentiment_data[0];
                } else {
                    this.sentimentData = this.sentimentResponseData.sentiment_data.filter(
                        (e) => {
                            if (e.period == target_period) {
                                return e;
                            }
                        }
                    )[0];
                }

                this.filteredExpertList = this.sentimentData
                    ? this.sentimentData.experts_data
                    : [];

                this.isCompareSectionOpen = true;

                if (this.sentimentData) {
                    var total =
                        this.sentimentData.market_sentiments.buy +
                        this.sentimentData.market_sentiments.hold +
                        this.sentimentData.market_sentiments.sell;

                    // `${(this.sentimentData.market_sentiments.buy / total) * 100}%`;

                    if (this.sentimentData.market_sentiments.buy > 0) {
                        this.donutGraphDetails.push({
                            value: this.sentimentData.market_sentiments.buy,
                            name: `${(this.sentimentData.market_sentiments.buy / total) *
                                100}%`,
                            valueInPercent: `${(this.sentimentData.market_sentiments.buy /
                                total) *
                                100}%`,
                            itemStyle: { color: "#61da5e" },
                        });
                    }
                    if (this.sentimentData.market_sentiments.sell > 0) {
                        this.donutGraphDetails.push({
                            value: this.sentimentData.market_sentiments.sell,
                            name: `Sell`,
                            itemStyle: { color: "#f2510e" },
                        });
                    }
                    if (this.sentimentData.market_sentiments.hold > 0) {
                        this.donutGraphDetails.push({
                            value: this.sentimentData.market_sentiments.hold,
                            name: "Hold",
                            itemStyle: { color: "#f1ae16" },
                        });
                    }

                    this.donutGraphDetails.push({
                        value: total,
                        name: null,
                        itemStyle: { opacity: 0 },
                        tooltip: { show: false },
                    });

                    setTimeout(() => {
                        this.initDonutGraphComponent();
                    }, 1000);
                    this.activeTab = 'Price Sentiment'

                } else {
                    this.showTechnicalAnalysisWidget()
                }
            } else {
                this.showTechnicalAnalysisWidget()
            }
        },
        filterSentimentDataByTargetPeriod() { },
        initDonutGraphComponent() {
            let donutGraphComponentContainer = this.$refs["reco_graph"];
            this.donutGraphInstance = echarts.init(
                donutGraphComponentContainer,
                null,
                this.initOptions
            );

            this.sendGraphDetails();
            // window.onresize = function() {
            //   plot.resize();
            // };
        },
        clearGraph() {
            this.donutGraphInstance.clear();
        },

        reRenderGraph() {
            this.clearGraph();
            this.donutGraphInstance.setOption(this.donutGraph);
        },
        sendGraphDetails() {
            this.donutGraphData = this.donutGraphDetails;

            this.reRenderGraph();
        },
    },
    computed: {
        // returns user profile from localstorage
        // userProfile() {
        //   return JSON.parse(localStorage.getItem("profile"));
        // },

        // returns selected market details from live price ticker component
        selectedMarketType() {
            return this.$store.state.selected_market_type;
        },

        subscribedPlanDetails() {
            return JSON.parse(localStorage.getItem("plan_details"));
        },
    },
};
</script>
    
<style lang="scss" scoped>
@import "../../css/common.scss";
@import "../../css/variable.scss";

.MarketSentimentCard {

    .NoDataFound {
        padding: 150px 0 0 0;
    }

    .no-data-container {
        max-width: 300px;
        border: 1px solid $secondary-theme-color;
        padding: 8px;
        margin: 50px auto;
        color: $secondary-theme-color;
        font-size: 13px;
        font-weight: 300;
        border-radius: 6px;
    }

    .innerSentimentCard {
        .sentiment-options {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .stock-details {

            // margin-top: 30px;
            .stock-name {
                font-weight: 500;
                color: #000;
                font-size: 1.1rem;
                margin: 5px 0;

                .more-btn {
                    font-size: 10px;
                    padding: 0px 8px 1px;
                    border: 1px solid;
                    color: #409eff;
                    border-radius: 8px;
                    position: relative;
                    bottom: 4px;
                }
            }

            .stock-price {
                color: #000;
                font-size: 0.9rem;
                margin: 5px 0;
                font-weight: 500;

                span {
                    font-size: 0.65rem;
                }
            }

            .stock-date {
                font-size: 0.7rem;
                color: #8d8a8a;
            }

            .btn-blocks {
                display: flex;
                flex-wrap: wrap;
                margin: 20px 0;

                .plane-btn {
                    font-size: 0.7rem;
                    padding: 3px 15px;
                    border: 1px solid black;
                    color: black;
                    border-radius: 12px;
                    margin-right: 5px;
                    text-transform: uppercase;
                }
            }
        }

        .expert-view {
            .market-type-dropdown {
                width: 85%;
                background-color: #f2f2f2;
                border-radius: 10px;
                padding: 0px 15px;
                align-items: center;
                justify-content: space-between;

                .target-period {
                    width: 110px;
                    border-right: 1px solid #b7b7b7;
                    color: #969696;
                    font-size: 0.75rem;
                    padding: 6px 0;
                    padding-right: 5px;
                }
            }
        }

        .graph-section {
            .percentage-txt {
                font-size: 10px;
                position: relative;
                bottom: 20px;
                font-weight: 600;
                color: #818181;
            }

            #reco_graph {}

            .antestimate {
                font-size: 12px;
                display: flex;
                justify-content: center;

                .antestimate-card {
                    text-align: center;
                    width: 125px;
                    height: 65px;
                    color: #ffff;
                    background-color: #0e0f4f;
                    border: 1px solid;
                    padding: 15px 10px;
                    border-radius: 10px;
                    margin-right: auto;
                    margin-top: 79px;

                    .mid-head {
                        font-size: 1.4rem;
                        margin: 5px 0;
                    }
                }
            }
        }

        .see-more-tabs {
            color: #1a7bde;
            cursor: pointer;
            z-index: 1;
            position: relative;
        }

        .forecasted-user-table-outer {
            overflow-x: auto;
        }

        .forecasted-user-table {
            width: 100%;
            border-collapse: collapse;

            th {
                color: #818181;
                font-size: 11px;
                font-weight: 600;
                padding: 5px 10px;
                border-bottom: 1px solid #ddd;
            }

            td {
                font-size: 11px;
                font-weight: 500;
                text-align: center;
                padding: 10px;
            }

            td:first-child {
                font-weight: 600;
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .MarketSentimentCard .innerSentimentCard .forecasted-user-table-one {
        width: 315px;
    }

    .MarketSentimentCard .innerSentimentCard .forecasted-user-table-two {
        width: 460px;
    }
}

@media screen and (max-width: 992px) {
    .MarketSentimentCard .innerSentimentCard .graph-section .antestimate .antestimate-card {
        margin: auto;
    }
}
</style>
    
<style lang="scss">
@import "../../css/common.scss";
@import "../../css/variable.scss";

.MarketSentimentCard {
    iframe {
        border: none !important;
    }

    .innerSentimentCard {
        .main-tabs {
            position: relative;
            z-index: 0;

            .el-tabs--border-card {
                border-top: 0;
            }

            .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
                color: $secondary-theme-color;
            }

            .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
                border: 1px solid #dcdfe6;
                border-bottom: 0;
                color: $secondary-theme-color;
                font-weight: 600;
            }

            .el-tabs--border-card>.el-tabs__header {
                background-color: #ffffff;
                border: none;
            }

            .el-tabs--border-card {
                border: none;
                box-shadow: none;
            }

            .el-tabs__content {
                background: #fff;
                border: 1px solid #dcdfe6;
                box-shadow: 0 2px 4px 0 #0000001f, 0 0 6px 0 #0000000a;
                padding-top: 0px;
            }

            .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
                margin-left: 0px;
            }

            .el-tabs--border-card>.el-tabs__header .el-tabs__item {
                margin-top: 2px;
                font-size: 0.8rem;
                height: 42px;
                font-weight: 600;
            }

            .price-sentiment-inner-card {
                height: 533px;
                overflow-y: auto;
                margin-top: 20px;

                .el-tabs__item {
                    font-size: 0.8rem;
                    height: 35px;
                    color: #9c9c9c;
                }

                .el-tabs__content {
                    background: none;
                    border: none;
                    box-shadow: none;
                }

                .el-tabs__nav-wrap::after {
                    display: none;
                }

                .el-tabs__item.is-active,
                .el-tabs__item:hover {
                    color: $primary-theme-color;
                }

                .el-tabs__active-bar {
                    background-color: $primary-theme-color;
                }
            }
        }

        .expert-view {
            .market-type-dropdown {
                .el-input__inner {
                    border-color: transparent;
                    background: #f2f2f2;
                    font-size: 0.75rem;
                }

                .el-select .el-input__inner:focus {
                    border-color: transparent !important;
                }

                .el-select .el-input .el-select__caret {
                    color: #000000;
                }
            }
        }

        .market-type-dropdown {
            display: flex;
            background: $primary-theme-color;
            padding: 5px 8px 6px;
            border-radius: 5px;
            margin-right: 6px;
            width: 100px;

            .el-dropdown {
                font-size: 11px;
                font-weight: 500;
                width: 100px;
            }

            i.el-icon-arrow-down.el-icon--right,
            .active-menu-link {
                color: #ffff;
                font-weight: bolder;
                display: flex;
                justify-content: space-between;
            }

            .active-menu-link:hover {
                color: #ffff;
            }
        }

        .el-checkbox__label {
            font-size: 11px;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #1a7bde;
            border-color: #1a7bde;
        }

        .el-icon-info {
            color: #1a7bde;
        }
    }
}
</style>
    